import { Api } from '../api/api';
import { Injectable } from '@angular/core';
import {LocalDataSource} from '../../ng2-smart-table/lib/data-source/local/local.data-source';
import { Logger } from 'ionic-logging-service';
import {AlertData} from '../../interfaces/alert-data';

@Injectable()
export class TechnicalAlertProvider {
  private logger: Logger;

  alertData: Array<AlertData> = [];
  tableData: LocalDataSource = new LocalDataSource();
  activeAlertData: AlertData = new AlertData();

  constructor(public api: Api) {
  }

  private getLogger() {
    if(this.logger) {
      return this.logger;
    }

    return this.logger = this.api.getLogger('Hausnotruf.TechnicalAlertProvider');
  }

  get() {
    return this.api.get('technicelalert');
  }

  getById(docId) {
    return this.api.get('alertDocTechnical', {docId});
  }



  quit(formData) {

    this.getLogger().info('quit', {message: 'Alarm quittiert', formData});

    return new Promise<void>((resolve, reject) => {
      this.activeAlertData.quit = {
        reason: formData.reason,
        comment: formData.comment,
        person: this.api._user.profile.firstname + ' ' + this.api._user.profile.lastname,
        dateTime: new Date().getTime()
      };
      this.api.put('quitAlertTechnical', {body: this.activeAlertData}).subscribe((resp: any) => {
        this.activeAlertData._rev = resp.data.data.rev;
        resolve();
      }, () => {
        reject();
      });
    });
  }

}
